import React from 'react';
import MuiAvatar from '@material-ui/core/Avatar';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = {
  root: { display: 'inline-block', marginTop: '1em', zIndex: 2 },
  avatar: {
    width: 96,
    height: 96,
  },
};

const Avatar = withStyles(styles)(({ classes, record }) => (
  <div className={classes.root}>
    <MuiAvatar className={classes.avatar} src={record.avatar_url} alt={record.full_name ? record.full_name : ''} />
  </div>
));

export default Avatar;



// WEBPACK FOOTER //
// ./src/containers/SalesAdvisor/Avatar.js